import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DataRest, ProfilesData } from '../model/api/data-rest';
import { EDeviceCategory } from '../conf/device-categories';
import { resources } from './api';


@Injectable({
    providedIn: 'root'
})
export class ProfilesService {

    constructor(private http: HttpClient) {}

    getDeviceProfiles(deviceId: number, categoryId: number, userId?: number): Observable<ProfilesData> {
        let params;
        if (typeof userId === 'undefined') {
            params = new HttpParams();
        } else {
            params = new HttpParams().set('userid', userId.toString());
        }
        let url = '';
        if (categoryId === EDeviceCategory.HomeAutomation) {
            url = `${environment.apiUrl}${resources.get('homeautomations')}/${deviceId}${resources.get('deviceProfiles')}`;
        } else {
            url = `${environment.apiUrl}${resources.get('alarmsystems')}/${deviceId}${resources.get('deviceProfiles')}`;
        }
        return this.http.get<ProfilesData>(url, { params });
    }

    updateDeviceProfile(deviceId: number, categoryId: number, id: number, checked: boolean, userId: number) {
        const params = new HttpParams().set('userid', userId.toString());
        let url = '';
        if (categoryId === EDeviceCategory.HomeAutomation) {
            url = `${environment.apiUrl}${resources.get('homeautomations')}/${deviceId}${resources.get('deviceProfiles')}/${id}`;
        } else {
            url = `${environment.apiUrl}${resources.get('alarmsystems')}/${deviceId}${resources.get('deviceProfiles')}/${id}`;
        }
        return this.http.patch<DataRest>(url, {Enable: checked}, { params });
    }

}
